<div class="button button__{{type}}"
    [class.button--disabled]="disabled"
>
    <ng-content></ng-content>
</div>
